import useDependPendingCallback from '@anm/hooks/useDependPendingCallback';
import useSwitchState from '@anm/hooks/useSwitchState';
import { appNotificationActions } from '@anm/store/modules/appNotifications';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useUserCard from '../../../../hooks/user/useUserCard';
import routes from '../../../../routes';
import { subscriptionSelectors } from '../../../../store/modules/subscription';

const { Router } = routes;

const useEditCreditCardModal = () => {
  const dispatch = useDispatch();
  const [isEditCreditCardOpen, openEditCreditCard, closeEditCreditCard] = useSwitchState();

  const card = useUserCard();
  const isHistoryPending = useSelector(subscriptionSelectors.selectHistoryPending);
  const [isCardFetched, cardFetched] = useSwitchState();

  useDependPendingCallback(isHistoryPending, cardFetched);

  const handleCloseModal = useCallback(() => {
    closeEditCreditCard();
    Router.pushRoute('pricing', undefined, { shallow: true });
  }, []);

  const isCardSuccessUpdated = useSelector(subscriptionSelectors.selectUpdateCardData);

  useEffect(() => {
    const isEditCard = Router.query.editCard as string;

    if (!isEditCard || !isCardFetched) return;

    !!card
      ? openEditCreditCard()
      : dispatch(
          appNotificationActions.notify({
            type: 'error',
            timeout: 60 * 60 * 1000,
            title: 'You have not credit card'
          })
        );
  }, [isCardFetched, card]);

  useEffect(() => {
    isCardSuccessUpdated && closeEditCreditCard();
  }, [isCardSuccessUpdated]);

  return [isEditCreditCardOpen, handleCloseModal] as const;
};

export default useEditCreditCardModal;
